import { startSlider } from './config.js';
import { SliderHelper } from './helpers/SliderHelper.js';

const SLIDER_AUTOPLAY_DELAY = 5000; // ms

const SLIDER_LOOP_OPTIONS = {
    wrapperSelector: '.swiper-wrapper',
    slideSelector: '.swiper-slide',
};

const SLIDER_CONTROLS_SELECTORS = {
    prevButton: '.header__hero-slider-actions-button--prev',
    nextButton: '.header__hero-slider-actions-button--next',
    timeline: '.header__hero-slider-actions-timeline',
    counter: '.header__hero-slider-actions-counter',
};

export const initSliderHomePageInHeaderHero = () => {
    const slider = document.getElementById('homePageInHeaderHero');

    // Не инициализируем слайдер, так как на экранах меньше 600px его не будет.
    if (!slider || window.matchMedia('(max-width: 600px)').matches) {
        return;
    }

    const sliderSlidesCount = SliderHelper.duplicateSlidesForStableLoop(slider, 2, SLIDER_LOOP_OPTIONS);
    const originalSlidesCount = SliderHelper.getOriginalSlidesCount(slider, SLIDER_LOOP_OPTIONS);
    const sliderControls = SliderHelper.getSliderControls(slider, SLIDER_CONTROLS_SELECTORS);

    SliderHelper.prepareSliderTimeline(sliderControls.timeline, { ariaLabel: 'Slide position' });

    const updateSlidePosition = (swiper) => {
        SliderHelper.updateSliderCounter(swiper, sliderControls.counter, originalSlidesCount);
        SliderHelper.setSliderTimelineProgress(
            sliderControls.timeline,
            SliderHelper.getRealSlideNumber(swiper, originalSlidesCount) / originalSlidesCount
        );
    };

    if (sliderSlidesCount && originalSlidesCount) {
        startSlider(
            slider.querySelector('.header__hero-slider-viewport'),
            {
                loop: true,
                loopAdditionalSlides: 4,
                loopPreventsSliding: false,
                centeredSlides: false,
                freeMode: false,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 20,
                speed: 650,
                grabCursor: true,
                navigation: {
                    prevEl: sliderControls.prevButton,
                    nextEl: sliderControls.nextButton,
                },
                autoplay: {
                    delay: SLIDER_AUTOPLAY_DELAY,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    0: {
                        spaceBetween: 16,
                    },
                    601: {
                        spaceBetween: 20,
                    },
                },
                on: {
                    init: updateSlidePosition,
                    slideChange: updateSlidePosition,
                },
            }
        );
    }
};
